type IconPropsType = {
  id: string
  width?: number | '100%'
  height?: number | '100%'
  className?: string
  props?: SVGElement
}

export default function Icon({
  id,
  width = '100%',
  height = '100%',
  className = '',
  ...props
}: IconPropsType): JSX.Element {
  return (
    <svg width={width} height={height} className={className} {...props}>
      <use xlinkHref={`/img/sprite.svg?2#${id}`}></use>
    </svg>
  )
}
